import { Fragment, useContext } from 'react'
import { Link } from 'react-router-dom'
import { AppContext } from '../App'
import profileData from '../data/profile.json'

export const LandingView = () => {
  const { isDesktopView } = useContext(AppContext)

  const { firstName, lastName, title, degree, contacts } = profileData.data

  const subtext = [title, degree]

  return (
    <div className='landing'>
      <section>
        <h2>The portfolio of...</h2>
        <h1>
          {lastName}, {firstName}
        </h1>
        <ul>
          {subtext.map((item, index) => (
            <Fragment key={index}>
              <li>{item}</li>
              {isDesktopView && index !== subtext.length - 1 && <li>○</li>}
            </Fragment>
          ))}
        </ul>
      </section>
      <div>
        <Link to='/index' className='go_to'>
          <span className='material-symbols-rounded'>arrow_right_alt</span>
        </Link>
        <div className='contacts'>
          {contacts.map((item, index) => {
            if (item.isHidden) {
              return <Fragment key={index}></Fragment>
            } else {
              return (
                <a
                  href={item.url}
                  target='_blank'
                  rel='noopener noreferrer'
                  key={index}>
                  <img src={item.src} alt={item.name} />
                </a>
              )
            }
          })}
        </div>
      </div>
    </div>
  )
}
